import React from 'react';
import globals from "../globals";
import HelmetDefault from "../layout/HelmetDefault";
import Hero from "../modules/Hero/Hero";
import Table from "../modules/Table";
import OutageGuarantee from "../modules/OutageGuarantee";
import RegisterBlock from "../modules/RegisterBlock";
import Heading from "../elements/Heading";
import CustomLink from "../elements/CustomLink";

class CloudConnectivity extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			title: '',
			subTitle: '',
			leadCopy: [],
			contentTitle: '',
			contentSubTitle: '',
			serviceAgreement: {},
			seoTitle: '',
			seoDescription: ''
		}
	}

	componentDidMount() {
		this.getData();
		this.controller1 = globals.genericAnimation(this.content1);
		this.controller2 = globals.genericAnimation(this.content2);
	}

	componentWillUnmount() {
		globals.destroy(this.controller1);
		globals.destroy(this.controller2);
	}

	getData() {
		fetch('/api/network-solutions/cloud-connectivity')
			.then(result => result.json())
			.then((result) => {
				this.setState(result);
				this.setDataReceived();
				globals.animatePageIn(this.container);
			});
	}

	setDataReceived() {
		this.setState({
			dataReceived: true
		});
	}

	render() {
		return (
			<div ref={(el) => this.container = el} style={{opacity: 0}} className="cloud-connectivity">
				<HelmetDefault {...this.state} />
				<Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
				<div className="row content-block">
					<div className="col-md-10 col-md-offset-1 col-xs-12" ref={el => this.content1 = el}>
						<Heading title={this.state.contentTitle} />
						<h3>From $150/mth for 1Gbps<br /><small>(for East Coast)</small></h3>
						<p><CustomLink to="/contact">Contact us</CustomLink> today to discuss your requirements.</p>
					</div>
					<div className="col-md-10 col-md-offset-1 col-xs-12 mt-5" ref={el => this.content2 = el}>
						<h2>{this.state.contentSubTitle}</h2>
						<img src="/images/cloud-connectivity-1.png" alt="Cloud connectivity infographic" />
					</div>
				</div>
				<Table data={this.state.serviceAgreement} image="/images/suitcase-dude.png" />
				<OutageGuarantee />
				<RegisterBlock />
			</div>
		);
	}

}

export default CloudConnectivity;


// WEBPACK FOOTER //
// ./resources/assets/js/networkSolutions/CloudConnectivity.js